import { type ComponentProps } from 'react';
import { StyleSheet, useWindowDimensions } from 'react-native';

import { LI } from '@expo/html-elements';
import { theme } from '@garnish/constants';

import { BodyText } from '../../../Text';

// ─────────────────────────────────────────────────────────────────────────────

export const Item = (props: ItemProps) => {
  const { direction, value, label } = props;

  const { width } = useWindowDimensions();

  // ─── Flags ───────────────────────────────────────────────────────────

  const isHorizontal = direction === 'horizontal';
  const isExtraSmallScreen = width < 375;

  // ─────────────────────────────────────────────────────────────────────

  const fontSizeMatch = isExtraSmallScreen ? TEXT_SIZE_MATCH_XS : TEXT_SIZE_MATCH;

  // ─────────────────────────────────────────────────────────────────────

  if (isHorizontal) {
    return (
      <LI style={styles.lineItemHorizontal}>
        <BodyText sizeMatch={fontSizeMatch}>
          <BodyText sizeMatch={fontSizeMatch} style={styles.nutritionDataText} bold>
            {value}
          </BodyText>

          <BodyText sizeMatch={fontSizeMatch}> </BodyText>

          <BodyText sizeMatch={fontSizeMatch} style={styles.label}>
            {label}
          </BodyText>
        </BodyText>
      </LI>
    );
  }

  return (
    <LI style={styles.lineItemVertical}>
      <BodyText sizeMatch={fontSizeMatch} style={styles.nutritionDataText} bold>
        {value}
      </BodyText>

      <BodyText sizeMatch={fontSizeMatch} style={styles.label}>
        {label}
      </BodyText>
    </LI>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  lineItemHorizontal: {
    flexDirection: 'row',
  },
  lineItemVertical: {
    flexDirection: 'column',
    gap: theme.spacing['1'],
  },
  nutritionDataText: {
    color: theme.colors.KALE,
  },
  label: {
    color: theme.colors.KALE,
  },
});

// ─── Constants ───────────────────────────────────────────────────────────────

const TEXT_SIZE_MATCH: ComponentProps<typeof BodyText>['sizeMatch'] = ['16'];
const TEXT_SIZE_MATCH_XS: ComponentProps<typeof BodyText>['sizeMatch'] = ['14'];

// ─── Types ───────────────────────────────────────────────────────────────────

type ItemProps = {
  direction: 'horizontal' | 'vertical';
  value: string | number;
  label: string;
};
